import { PieDatum } from '@evinced-private/ui-common';

import flatten from 'lodash/flatten';

import { EVINCED_SEVERITIES_BY_LABEL } from '../consts/severityIDs';
import { IssueSeverities } from '../interfaces/IssuesOverviewResponse';

import { ColorsHelper } from './charts/ColorsHelper';
import { formatTextToId } from './IdFormatterHelper';
import { calcPercentage } from './MathHelper';

export const getIssuesDistributionPieDataV2 = (
	issueSeverities: IssueSeverities[],
	totalIssues: number
): PieDatum[] => {
	const data = issueSeverities.map(({ types, severity }) =>
		types
			.map(({ type, issuesCount }) => {
				const value = calcPercentage(issuesCount, totalIssues);
				return {
					id: formatTextToId(`${type} ${severity}`),
					label: type,
					value,
					percent: value,
					color: ColorsHelper.newSeverityColors[EVINCED_SEVERITIES_BY_LABEL[severity]],
					severity,
					pagesCount: issuesCount
				};
			})
			.sort((datum1, datum2) => datum2.value - datum1.value)
	);
	return flatten(data);
};

export const getSeveritiesDistributionPieDataV2 = (
	issueSeverities: IssueSeverities[],
	totalIssues: number
): PieDatum[] => {
	return issueSeverities.map(({ severity, issuesCount }) => {
		const value = calcPercentage(issuesCount, totalIssues);
		return {
			id: formatTextToId(severity),
			value,
			percent: value,
			label: severity,
			color: ColorsHelper.newSeverityColors[EVINCED_SEVERITIES_BY_LABEL[severity]],
			pagesCount: issuesCount
		};
	});
};
